<template> 
  <form class="info-pages">
    <el-collapse accordion>
      <p v-if="pages.length == 0" class="pull-left pad-to-15">{{$t('settingsInfoPages.noPage')}}</p>
      <!-- <button class="btn btn-info pull-right mar-to-10" @click.prevent="addNewPage()">{{$t('general.add')}} {{$t('settingsInfoPages.single')}}</button> -->
      <p class="clearfix"></p>

      <template v-for="page in pages">
          <!-- <el-collapse-item :title="page.title" :name="page.id">
            <form class="c">
              <div class="form-group">
                <label>{{$t('settingsInfoPages.title')}}</label>
                <input type="text" :name="'title'+page.id" class="form-control" v-model="page.title" v-validate="{required: true}">
              </div>
              <div class="form-group">
                <label>{{$t('settingsInfoPages.content')}}</label>
                <textarea :name="'description'+page.id" class="form-control" v-model="page.description" v-validate="{required: true}" rows='12'></textarea>
              </div>
            </form> 
          </el-collapse-item>-->

       <!--    <textarea :name="'description'+page.id" class="form-control" v-model="page.description" v-validate="{required: true}" rows='12'></textarea> -->
        <el-collapse-item :title="$t('settingsInfoPages.' + page.type)" :name="page.id">
          <label class="pad-to-10">{{$t('settingsInfoPages.content')}}</label>
          <wysiwyg v-model="page.description" />
          <button @click.prevent="validate(page.id)" class="btn btn-success btn-fill mar-to-10">{{$t('general.save')}}</button>
        </el-collapse-item>
        
      </template>
    </el-collapse>
  </form>
</template>

<script>
  import Vue from 'vue'
  import {Input} from 'element-ui'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'
  import {mapFields} from 'vee-validate'
  import 'vue-wysiwyg/dist/vueWysiwyg.css'
  Vue.use(Input)

  export default {
    components: {
      [Input.name]: Input
    },
    data () {
      return {
        pages: []
      }
    },
    computed: {
      ...mapFields(['title', 'description'])
    },
    created: function () {
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }
      var self = this
      // get main categories
      this.apiRequest('/settings/infopages', 'GET', data, function (response) {
        if (response.status === true) {
          self.pages = response.data
        }
      })
    },
    methods: {
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate (pageId) {
        this.$validator.validateAll().then(isValid => {
          if (isValid) {
            this.savePage(pageId)
          }
        })
      },
      savePage (pageId) {
        console.warn(pageId)
        let thisPageIdx = this.getObjectByElemKeyValue('id', pageId, this.pages)
        var data = this.pages[thisPageIdx]
        data.token = this.$session.get('token')
        data.company_id = this.$session.get('selectedCompany')
        delete data.company
        var method = 'PUT'
        var linkId = '/' + data.id

        if (pageId === undefined || (!Number.isInteger(pageId) && pageId.indexOf('new') === 0)) {
          if (data.id) {
            delete data.id
          }
          method = 'POST'
          linkId = ''
        }
        var self = this
        this.apiRequest('/settings/infopages' + linkId, method, data, function (response) {
          if (response.status === true) {
            swal({'text': self.$t('settingsInfoPages.addedSuccess'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
            if (method === 'POST') {
              self.pages[thisPageIdx].id = response.data[0].id
            }
          } else {
            swal({'text': self.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
          }
        })
      },
      addNewPage () {
        let newPg = {
          'id': 'new_' + Math.floor(Math.random() * 10000),
          'title': this.$t('settingsInfoPages.newPage'),
          'description': ''
        }
        this.pages.push(newPg)
      },
      deletePage (pageId) {
        let thisPageIdx = this.getObjectByElemKeyValue('id', pageId, this.pages)

        // var btnCounter = 3
        var self = this
        swal({
          text: self.$t('settingsInfoPages.deleteMsg'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: self.$t('general.yes')
        })
        .then((result) => {
          if (result) {
            if (!Number.isInteger(pageId) && pageId.indexOf('new') === 0) {
              this.pages.splice(thisPageIdx, 1)
              swal({'text': self.$t('settingsInfoPages.deletedSuccess'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000})
            } else {
              var id = pageId
              var data = {
                id: id,
                token: this.$session.get('token'),
                company_id: this.$session.get('selectedCompany')
              }
              this.apiRequest('/settings/infopages/' + id, 'DELETE', data, function (response) {
                if (response.status === true) {
                  self.pages.splice(thisPageIdx, 1)
                  swal({'text': self.$t('settingsInfoPages.deletedSuccess'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000})
                } else {
                  swal({'text': self.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000})
                }
              })
            }
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/InfoPages/InfoPages.vue